import { useMutation } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { Entity } from '../../../../../types/utility';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postApplicationFormSubmit } from '../../requests/postApplicationForm';

export const useApplicationFormSubmit = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: submitForm, ...rest } = useMutation({
    mutationFn: ({
      uuid,
      data,
      params,
    }: {
      uuid: string;
      data: Entity;
      params?: RequestConfig['params'];
    }) =>
      postApplicationFormSubmit(
        constructPost,
        uuid,
        definitionName,
        data,
        params,
      ),
  });

  return { submitForm, ...rest };
};
